import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class LoadingController extends BridgeComponent {
  static component = "loading";

  showLoading() {
    this.send("show");
  }

  hideLoading() {
    this.send("hide");
  }
}
